import PropTypes from "prop-types";
import { useSelector } from 'react-redux';

/** Components */
import UnauthorizedPage from '../pages/unauthorizedPage/UnauthorizedPage';
import { canAccessModuleSurface } from '../utils/authentication/authorizeNavigation';

const AuthorizedRoute = ({ component: Component, securityKey, moduleCode }) => {
    const { isLoggedIn, isAuthenticated } = useSelector((state) => state.auth);

    if (isLoggedIn && isAuthenticated) {
        if (canAccessModuleSurface(moduleCode, securityKey)) {
            return <Component />;
        }
        return <UnauthorizedPage />;
    }

    return <UnauthorizedPage />;
};

export default AuthorizedRoute;

AuthorizedRoute.propTypes = {
    component: PropTypes.elementType.isRequired,
    securityKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    moduleCode: PropTypes.string,
};
